import { useState } from 'react';

export const useRidMutation = () => {
    const [ridLength, setRidLength] = useState(0);

    // Remove all non-numeric/non-dash characters from RID
    const mutateUiRid = (value: string) => {
        const newRidLength = value.length;
        const lastChar = value[newRidLength - 1];

        // Remove all non-numeric/non-dash characters from RID
        value = value.replace(/[^0-9-]/g, '');

        // Disallow dashes at other locations than 4th and 8th
        if (lastChar === '-' && newRidLength !== 4 && newRidLength !== 8) {
            value = value.slice(0, -1);
            setRidLength(value.length);
            return value;
        }
        // Allow delete of last number with auto-add dash at the 8th position
        if (newRidLength < ridLength && newRidLength === 7 && value.includes('-')) {
            value = value.slice(0, -1);
            setRidLength(value.length);
            return value;
        }
        // Auto-Add dash at the 8th position if the seventh position was just typed and a dash was used previously
        value = value.length === 7 && value.includes('-') ? value.concat('-') : value;

        /**
         * Disallow more than 7 digits and 2 dashes
         */
        value = value.replace(/(?<=[0-9]{7}).*|(?<=[0-9-]{9}).*|(?<=^\d{3}-\d{3}-\d{1}).*/g, '');
        setRidLength(value.length);
        return value;
        // return value.replace(/(?<=[0-9]{7}).*|(?<=[0-9-]{9}).*/g, '');
    };

    return {
        mutateUiRid,
    };
};
